import { Map } from 'immutable'
import { createReducer } from '@cheesecakelabs/boilerplate/utils'

import { LOGOUT } from '../user/actions'

import { CREATE_NOTIFICATION, CLEAR_NOTIFICATIONS, DELETE_NOTIFICATION } from './actions'

export const INITIAL_STATE = new Map()

export const notifications = createReducer(INITIAL_STATE, {
  [CREATE_NOTIFICATION]: (state, { payload }) => {
    const message = `Take a Break, ${payload.breakName}`
    const id = Math.floor(Math.random() * 5000)

    const newNotification = {
      id,
      breakName: payload.breakName,
      message,
      type: payload.reminderType,
    }

    return state.merge({
      [id]: newNotification,
    })
  },

  [CLEAR_NOTIFICATIONS]: () => INITIAL_STATE,

  [DELETE_NOTIFICATION]: (state, { payload }) => state.delete(payload.id),

  [LOGOUT]: () => INITIAL_STATE,
})



// WEBPACK FOOTER //
// ./src/modules/notification/reducers.js